import { matchIsMobileMode, ReactNativeMessages } from '@taxfix/scouts-helpers'

import { useProfile } from '@/store/profile'

import { useSelfEmployedPlatformVisibility } from './self-employed-platform/use-self-employed-platform-visibility'

// @TODO: Move hook to scouts-helpers and accept data as an argument
export const useUpdateReactNative = () => {
    const { profile } = useProfile()
    const { shouldDisplaySelfEmployedPlatform } = useSelfEmployedPlatformVisibility()

    const updateReactNative = () => {
        matchIsMobileMode(
            () => {
                ReactNativeMessages.profile({
                    ...profile,
                    shouldDisplaySelfEmployedPlatform,
                })
            },
            () => {}
        )
    }

    return { updateReactNative }
}
